import createReactComponent from '../createReactComponent';
export default createReactComponent('move-diagonal-one', 'MoveDiagonalOne', [["path",{"d":"M5 11V5m0 0h6M5 5l14 14m0-6v6m0 0h-6","key":"svg-0"}]]);